<script setup>
  import {
    ref
  } from 'vue'

  import { useI18n } from '@shared/i18n.js'

  const sort = ref(window.app.page.search_key.sort || '')

  const { vt } = useI18n('properties.index.js')

  const submit = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('sort')
    url.searchParams.append('sort', sort.value)
    window.location.href = url.toString()
  }
</script>

<template>
  <div class="sort_item">
    <label class="select_type_a">
      <select v-model="sort" class="search-price-to for-sale" @change="submit">
        <option value="">{{ vt('relevant_listings') }}</option>
        <option value="purpose desc">{{ vt('sort_by_purpose') }}</option>
        <option value="gross_yield desc">{{ vt('sort_by_gross_yield_higher') }}</option>
        <option value="price asc">{{ vt('sort_by_price_lower') }}</option>
        <option value="price desc">{{ vt('sort_by_price_higher') }}</option>
        <option value="floor_size desc">{{ vt('sort_by_home_size_higher') }}</option>
        <option value="land_size desc">{{ vt('sort_by_land_size_higher') }}</option>
        <option value="completion desc">{{ vt('sort_by_home_age_higher') }}</option>
      </select>
    </label>
  </div>
</template>
